interface Tab {
  key: string;
  label: string;
}

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: Tab[];
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
  tabs,
}) => {
  return (
    <div className="d-flex">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`btn fw-semibold px-5 py-2 ${
            activeTab === tab.key
              ? "text-primary border-bottom border-primary"
              : "text-secondary"
          }`}
          style={{
            background: "transparent",
            borderBottomWidth: activeTab === tab.key ? "2px" : "1px",
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;